export class ApplicationData {
    pollingInterval: number = 300000;
    dateFormat: string = 'MM/dd/YYYY HH:mm';
}
